import { jsx as _jsx } from "react/jsx-runtime";
import { Controller, useFormContext } from 'react-hook-form';
import { DatePicker, DateTimePicker, DateRangePicker, } from '@tribeplatform/react-ui-kit/DateTimePicker';
import { FormControl, extractLayoutProps, } from '@tribeplatform/react-ui-kit/FormControl';
import { dayjs } from '../../common/lib/dayjs';
const renderElement = ({ type, ...rest }) => {
    switch (type) {
        case 'date':
            return _jsx(DatePicker, { ...rest }, void 0);
        case 'datetime-local':
            return _jsx(DateTimePicker, { ...rest }, void 0);
        case 'date-range':
            return _jsx(DateRangePicker, { ...rest }, void 0);
        default:
            // Code should never reach the default case
            // eslint-disable-next-line no-case-declarations
            const exhaustiveCheck = type;
            return exhaustiveCheck;
    }
};
const removeTimezoneData = (date) => {
    if (!date) {
        return undefined;
    }
    return dayjs(date).format('YYYY-MM-DDTHH:mm:ss');
};
const cleanTimezone = (value) => {
    return Array.isArray(value)
        ? value.map(removeTimezoneData)
        : removeTimezoneData(value);
};
export function FormDateTime({ name, validation, onChange: fieldOnChange, type = 'date', ...rest }) {
    const { control } = useFormContext();
    return (_jsx(Controller, { control: control, name: name, rules: validation, render: ({ field: { onChange, value }, fieldState: { error, invalid }, }) => {
            const { layoutProps, inputProps } = extractLayoutProps({
                ...rest,
                name,
                invalid,
                error: error === null || error === void 0 ? void 0 : error.message,
            });
            return (_jsx(FormControl.Layout, { ...layoutProps, children: renderElement({
                    type,
                    invalid,
                    value: cleanTimezone(value),
                    onChange: value => {
                        const localValue = cleanTimezone(value);
                        onChange(localValue);
                        if (typeof fieldOnChange === 'function') {
                            fieldOnChange(localValue);
                        }
                    },
                    ...inputProps,
                }) }, void 0));
        } }, void 0));
}
//# sourceMappingURL=FormDateTime.js.map